/* eslint-disable */
// @ts-nocheck
export function initHeroSampleFormat() {
  // Match platform formatQuantity — 3 significant figures.
  function formatQuantity(value, sigFigs) {
    var digits = sigFigs || 3
    if (value == null || isNaN(value)) return '--'
    if (value === 0) return '0'
    return value.toLocaleString('en-US', { maximumSignificantDigits: digits })
  }
  window.formatQuantity = formatQuantity

  var PANEL_UNITS = {
    nmc: { massFactor: 1 },
    citric: { massFactor: 1 },
    soc: { massFactor: 1000 },
  }

  function applyRowFormats() {
    var nodes = window.MI_NODES || {}
    document.querySelectorAll('.mi-tabpanel').forEach(function (panel) {
      var cfg = PANEL_UNITS[panel.getAttribute('data-panel')] || {
        massFactor: 1,
      }
      panel.querySelectorAll('.mi-row[data-i]').forEach(function (row) {
        var node = nodes[row.getAttribute('data-i')]
        if (!node) return
        var vals = row.querySelectorAll('.mi-row__val')
        if (vals[0]) {
          var massNum = vals[0].querySelector('.num')
          if (massNum)
            massNum.textContent = formatQuantity(node.mass * cfg.massFactor)
        }
        if (vals[1]) {
          var costNum = vals[1].querySelector('.num')
          if (costNum) costNum.textContent = '$' + formatQuantity(node.cost)
        }
      })
    })
  }

  // Sourcing-country pill on each product's root row, right after the name,
  // driven from the root node's `sources` so it stays truthful.
  var PANEL_ROOT = { nmc: 'n0', citric: 'c0', soc: 's0' }
  var PIN =
    '<svg viewBox="0 0 16 16" fill="none"><path d="M8 1.9c-2.37 0-4.2 1.86-4.2 4.2 0 3 4.2 7 4.2 7s4.2-4 4.2-7c0-2.34-1.83-4.2-4.2-4.2Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="8" cy="6.1" r="1.45" stroke="currentColor" stroke-width="1.3"/></svg>'

  function dominantSource(node) {
    var src = node && node.sources
    if (!src || !src.length) return null
    return src.reduce(function (a, b) {
      return (b.p || 0) > (a.p || 0) ? b : a
    })
  }

  function applyRowSourcing() {
    // Sourcing column is hidden — show the country as an inline chip after the PRODUCT name only.
    var nodes = window.MI_NODES || {}
    document.querySelectorAll('.mi-tabpanel').forEach(function (panel) {
      var rootKey = PANEL_ROOT[panel.getAttribute('data-panel')]
      if (!rootKey) return
      var row = panel.querySelector('.mi-row[data-i="' + rootKey + '"]')
      if (!row) return
      var label = row.querySelector('.mi-row__label')
      if (!label || row.querySelector('.mi-row__src')) return // idempotent
      var dom = dominantSource(nodes[rootKey])
      if (!dom) return
      var pill = document.createElement('span')
      pill.className = 'mi-row__src'
      pill.innerHTML =
        PIN + '<span class="lbl">Sourcing:</span><span>' + dom.n + '</span>'
      pill.setAttribute('title', 'Sourced from ' + dom.n)
      label.insertAdjacentElement('afterend', pill)
    })
  }

  window.applyRowFormats = applyRowFormats
  window.applyRowSourcing = applyRowSourcing

  applyRowFormats()
  applyRowSourcing()
}
